(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OnuService', OnuService);

    OnuService.$inject = ['$http', '$q', '$filter', 'RequestService', 'ModalConstructor', 'AlertModalService', 'OnuData'];

    function OnuService($http, $q, $filter, RequestService, ModalConstructor, AlertModalService, OnuData) {

        var service = {
            getOnu: getOnu,
            getUnauthorizedOnuList: getUnauthorizedOnuList,
            getAuthorizedOnuList: getAuthorizedOnuList,
            getGponSlot: getGponSlot,
            getModelList: getModelList,
            authorizeOnu: authorizeOnu,
            restartOnu: restartOnu,
            deleteOnu: deleteOnu,
            updateOnu: updateOnu,
            resetOnu: resetOnu,
            updateNameOnu: updateNameOnu,
            getFiles: getFiles,
            saveOnuCredentials: saveOnuCredentials,
            getONTStatusVoip: getONTStatusVoip,
            getOnuCpeMgr: getOnuCpeMgr,
            deleteAllCpeMgr: deleteAllCpeMgr,
            // Methods Onu Settings
            getSettingsWifi: getSettingsWifi,
            updateSettingsWifi: updateSettingsWifi,
            // Modal Methods
            editOnuModalConstructor: editOnuModalConstructor,
            configAccessModalConstructor: configAccessModalConstructor,
            authorizeOnuModalConstructor: authorizeOnuModalConstructor,
            successModalConstructorNotClose: successModalConstructorNotClose,
            successModalConstructor: successModalConstructor,

            warningModalConstructor: warningModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            configOnuModalConstructor: configOnuModalConstructor,
            openModalONTStatusVoip: openModalONTStatusVoip,
            openModalOnuRemoteMgmt: openModalOnuRemoteMgmt,
            updateOnuModalConstructor: updateOnuModalConstructor,
            infoModalConstructor: infoModalConstructor,
            getAuthorizedOnuVmList: getAuthorizedOnuVmList
        };

        return service;

        function getUnauthorizedOnuList(data, hideSpinner) {
            checkSearch(data);            
            return $http.get(onuApi('unauthorized'), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function getAuthorizedOnuList(data, hideSpinner) {
            checkSearch(data);
            //return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
            return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner});
        }

        function getAuthorizedOnuVmList(data, hideSpinner) {
            //console.log(!!hideSpinner);
            checkSearch(data);
            //return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
            return $http.get(onuApi('authorizedvm'), {params: data, ignoreLoadingBar: !!hideSpinner});
        }

        function getGponSlot(gponPortId) {
            return $http.get(onuApi(gponPortId + '/availablegponslots')).then(responseData);
        }

        function getModelList() {
            return $http.get(onuApi('/meprofilelist')).then(responseData);
        }

        function authorizeOnu(data) {
            return $http.post(onuApi(), data).then(responseData);
        }

        function updateNameOnu(onuId, onuName) {
            var onuData = {
                id: onuId,
                name: onuName
            }
            return $http.put(onuApi(), onuData).then(responseData);
        }

        function saveOnuCredentials(data) {
            return $http.put(onuApi('credentials'), data).then(responseData);
        }

        function deleteOnu(onuData) {
            var onuIds = onuData.map(onuId);
            return $http.delete(onuApi(onuIds));
        }

        function restartOnu(onuData) {
            var onuIds = onuData.map(onuId);
            return $http.put(onuApi(onuIds + '/restart'));
        }

        function getFiles(onuIds) {
            return $http.get(onuApi('oltfiles/' + onuIds)).then(responseData);
        }

        function updateOnu(data) {
            return $http.put(onuApi('fwupdate'), data).then(responseData);
        }

        function resetOnu(data) {
            var onuIds = data.map(onuId);
            return $http.put(onuApi(onuIds + '/reset'));
        }

        // Methods for Onu Settings
        function getSettingsWifi(onuId) {
            return $http.get(configApi(onuId + '/wifi')).then(responseData);
        }

        function updateSettingsWifi(data) {
            return $http.put(configApi('wifi'), data).then(responseData);
        }

        // Helper Functions

        // API Functions
        function onuApi(method) {
            return RequestService.apiUrl('onus', method);
        }

        function configApi(method) {
            return RequestService.apiUrl('onuconfig', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function onuId(item) {
            return item.id;
        }

        function checkSearch(data) {
            OnuData.setSearch(false);
            if (data && !data.noSearch) {
                var params = Object.keys(data);
                if (params.length) {
                    OnuData.setSearch(true);
                }
            }
        }

        // Modal Methods
        function editOnuModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-edit-authorized.html',
                controller: 'EditAuthorizedOnuController',
                controllerAs: 'vmEditAuthorizedOnu',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function configAccessModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-config-access.html',
                controller: 'ConfigAccessOnuController',
                controllerAs: 'vmConfigAccessOnu',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function authorizeOnuModalConstructor(onuItem) {
            var authorizeOnu = {
                templateUrl: 'app/components/onu/onu-authorize.html',
                controller: 'AuthorizeOnuController',
                controllerAs: 'vmAuthorizeOnu',
                size: 'sm',
                windowClass: 'modal-onu-authorize',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(authorizeOnu);
        }

        function confirmationModalConstructor(onusData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/onu/onu-confirm.html',
                controller: 'OnuConfirmController',
                controllerAs: 'vmOnuConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    onuList: function () {
                        return onusData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        function configOnuModalConstructor(onuItem, isOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-config.html',
                controller: 'ConfigOnuController',
                controllerAs: 'vmConfigOnu',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                    isOnu: function () {
                        return isOnu
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('onu-modals');
                            return $translate.refresh();
                        }]
                }
            };
            return ModalConstructor.open(modal);
        }

        function getONTStatusVoip(idOnu) {
            return $http.get(onuApi(idOnu + '/statusVoip')).then(responseData);
        }

        function openModalONTStatusVoip(idOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-status-voip.html',
                controller: 'OnuStatusVoipController',
                controllerAs: 'vmOnuStatusVoip',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    idOnu: function () {
                        return idOnu
                    }
                }
            };
            return ModalConstructor.open(modal);
        }

        function getOnuCpeMgr(idOnu) {
            return $http.get(onuApi(idOnu + "/cpemgr")).then(responseData);
        }

        function getOnu(idOnu) {
            return $http.get(onuApi(idOnu)).then(responseData);
        }
        
        function deleteAllCpeMgr(oltId) {
            return $http.delete(onuApi('cpemgr' + '?oltId=' + oltId));
        }

        function openModalOnuRemoteMgmt(idOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-remote-mgmt.html',
                controller: 'OnuRemoteMgmtController',
                controllerAs: 'vmOnuRemoteMgmt',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    idOnu: function () {
                        return idOnu
                    }
                }
            };
            return ModalConstructor.open(modal);
        }

        function updateOnuModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-update-firmware.html',
                controller: 'OnuUpdateFirmwareController',
                controllerAs: 'vmOnuUpdateFirmware',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function successModalConstructorNotClose(action, isMultiple) {

            var alertType = 'single';

            if (isMultiple) {
                alertType = 'multiple';
            }

            var successTemplate = {
                templateUrl: 'app/shared/alert/alert-success.html',
                controller: successController,
                controllerAs: 'vmAlertSuccess',
                size: 'sm',
                windowClass: 'modal-alert modal-success',
                avoidCancel: true
            };

            ModalConstructor.open(successTemplate);

            successController.$inject = ['$uibModalInstance'];
            function successController($uibModalInstance) {

                // Generate the translation key based on action and state
                this.modalMessage = 'onu' + 'Success.response.' + action + '.message.' + alertType;

                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'onu');
        }

        function warningModalConstructor(list, response, action) {
            AlertModalService.warning(list, response, action, 'onu');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'onu');
        }

        function infoModalConstructor(dataAction) {
            var info = {
                templateUrl: 'app/components/onu/onu-info.html',
                controller: 'OnuInfoController',
                controllerAs: 'vmOnuInfo',
                size: 'sm',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('onu-modals');
                            return $translate.refresh();
                        }]
                },
                avoidCancel: true
            };
            ModalConstructor.open(info);
        }

    }
})();
